// **  Initial State
const initialState = {

}

export const trainingReducer = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state
	}
}
